<template>
  <el-option v-bind="$attrs">
    <template v-for="(_, name) in $slots">
      <slot :name="name" />
    </template>
  </el-option>
</template>

<script>
export default {
  name: 'SpOption',
};
</script>
